<!--
  Vertical "today" indicator line rendered inside a gantt-elastic chart.
  gantt-elastic renders a task row component by its `type` name, so a task
  with `type: 'GanttTodayLine'` resolves to this component. The line is drawn
  at the task's x position and spans the full chart height.
-->
<template>
  <line
    class="gantt-elastic__today-line"
    :x1="task.x"
    :y1="0"
    :x2="task.x"
    :y2="root.state.options.allVisibleTasksHeight"
    :style="root.style['chart-today-line']"
  ></line>
</template>

<script>
export default {
  name: 'GanttTodayLine',
  inject: ['root'],
  props: ['task']
};
</script>
